// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v7.34.1
// source: agent_settings.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "agent";

/** Main AgentSettings message containing all agent components */
export interface AgentSettings {
  greeting: Greeting[];
  personality: Personality | undefined;
  role: Role | undefined;
  disclaimerMessage: DisclaimerMessage[];
  rules:
    | Rules
    | undefined;
  /** Map language code to LanguageBehavior object */
  languageBehaviors: { [key: string]: LanguageBehavior };
}

export interface AgentSettings_LanguageBehaviorsEntry {
  key: string;
  value: LanguageBehavior | undefined;
}

/** Greeting component */
export interface Greeting {
  welcomeMessage: string;
  createdAt: string;
  createdBy: string;
  updatedAt?: Date | undefined;
  updatedBy?: string | undefined;
  references?: GreetingReferences | undefined;
  languageCode: string;
}

export interface GreetingUpdateGreeting {
  welcomeMessage?: string | undefined;
  references?: GreetingReferences | undefined;
  languageCode: string;
}

export interface GreetingReferences {
  variables: { [key: string]: boolean };
  translations: { [key: string]: boolean };
}

export interface GreetingReferences_VariablesEntry {
  key: string;
  value: boolean;
}

export interface GreetingReferences_TranslationsEntry {
  key: string;
  value: boolean;
}

/** Personality component */
export interface Adjectives {
  values: { [key: string]: boolean };
}

export interface Adjectives_ValuesEntry {
  key: string;
  value: boolean;
}

export interface Personality {
  adjectives: { [key: string]: boolean };
  custom: string;
  createdAt: string;
  createdBy: string;
  updatedAt?: Date | undefined;
  updatedBy?: string | undefined;
  references?: PersonalityReferences | undefined;
}

export interface Personality_AdjectivesEntry {
  key: string;
  value: boolean;
}

export interface PersonalityUpdatePersonality {
  adjectives?: Adjectives | undefined;
  custom?: string | undefined;
  references?: PersonalityReferences | undefined;
}

export interface PersonalityReferences {
  variables: { [key: string]: boolean };
}

export interface PersonalityReferences_VariablesEntry {
  key: string;
  value: boolean;
}

/** Role component */
export interface Role {
  value: string;
  additionalInfo: string;
  custom: string;
  createdAt: string;
  createdBy: string;
  updatedAt?: Date | undefined;
  updatedBy?: string | undefined;
  references?: RoleReferences | undefined;
}

export interface RoleUpdateRole {
  value?: string | undefined;
  additionalInfo?: string | undefined;
  custom?: string | undefined;
  references?: RoleReferences | undefined;
}

export interface RoleReferences {
  variables: { [key: string]: boolean };
}

export interface RoleReferences_VariablesEntry {
  key: string;
  value: boolean;
}

/** Disclaimer message component */
export interface DisclaimerMessageReferences {
  translations: { [key: string]: boolean };
}

export interface DisclaimerMessageReferences_TranslationsEntry {
  key: string;
  value: boolean;
}

export interface DisclaimerMessage {
  isEnabled: boolean;
  message: string;
  ringingTone: AudioToPlay | undefined;
  createdAt: string;
  createdBy: string;
  updatedAt?: Date | undefined;
  updatedBy?: string | undefined;
  languageCode: string;
  references?: DisclaimerMessageReferences | undefined;
}

export interface DisclaimerMessageUpdateDisclaimerMessage {
  isEnabled?: boolean | undefined;
  message?: string | undefined;
  ringingTone?: UpdateRingingTone | undefined;
  languageCode: string;
  references?: DisclaimerMessageReferences | undefined;
}

export interface UpdateRingingTone {
  s3Path?: string | undefined;
  originalFilename?: string | undefined;
  publicUrl?: string | undefined;
}

export interface AudioToPlay {
  s3Path: string;
  originalFilename: string;
  publicUrl: string;
}

/** Rules component */
export interface RulesReferences {
  sms: { [key: string]: boolean };
  handoff: { [key: string]: boolean };
  attributes: { [key: string]: boolean };
  globalFunctions: { [key: string]: boolean };
  variables: { [key: string]: boolean };
  translations: { [key: string]: boolean };
}

export interface RulesReferences_SmsEntry {
  key: string;
  value: boolean;
}

export interface RulesReferences_HandoffEntry {
  key: string;
  value: boolean;
}

export interface RulesReferences_AttributesEntry {
  key: string;
  value: boolean;
}

export interface RulesReferences_GlobalFunctionsEntry {
  key: string;
  value: boolean;
}

export interface RulesReferences_VariablesEntry {
  key: string;
  value: boolean;
}

export interface RulesReferences_TranslationsEntry {
  key: string;
  value: boolean;
}

export interface Rules {
  behaviour: string;
  references: RulesReferences | undefined;
  createdAt: string;
  createdBy: string;
  updatedAt?: Date | undefined;
  updatedBy?: string | undefined;
}

export interface RulesUpdateRules {
  behaviour?: string | undefined;
  references?: RulesReferences | undefined;
}

/** Language behavior component */
export interface LanguageBehaviorReferences {
  sms: { [key: string]: boolean };
  handoff: { [key: string]: boolean };
  attributes: { [key: string]: boolean };
  globalFunctions: { [key: string]: boolean };
  variables: { [key: string]: boolean };
}

export interface LanguageBehaviorReferences_SmsEntry {
  key: string;
  value: boolean;
}

export interface LanguageBehaviorReferences_HandoffEntry {
  key: string;
  value: boolean;
}

export interface LanguageBehaviorReferences_AttributesEntry {
  key: string;
  value: boolean;
}

export interface LanguageBehaviorReferences_GlobalFunctionsEntry {
  key: string;
  value: boolean;
}

export interface LanguageBehaviorReferences_VariablesEntry {
  key: string;
  value: boolean;
}

export interface LanguageBehavior {
  behaviorPrompt: string;
  languageCode: string;
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt?: Date | undefined;
  updatedBy?: string | undefined;
  references: LanguageBehaviorReferences | undefined;
}

export interface LanguageBehaviorUpdateLanguageBehavior {
  languageCode: string;
  behaviorPrompt?: string | undefined;
  references?: LanguageBehaviorReferences | undefined;
}

function createBaseAgentSettings(): AgentSettings {
  return {
    greeting: [],
    personality: undefined,
    role: undefined,
    disclaimerMessage: [],
    rules: undefined,
    languageBehaviors: {},
  };
}

export const AgentSettings: MessageFns<AgentSettings> = {
  encode(message: AgentSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.greeting) {
      Greeting.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.personality !== undefined) {
      Personality.encode(message.personality, writer.uint32(18).fork()).join();
    }
    if (message.role !== undefined) {
      Role.encode(message.role, writer.uint32(26).fork()).join();
    }
    for (const v of message.disclaimerMessage) {
      DisclaimerMessage.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.rules !== undefined) {
      Rules.encode(message.rules, writer.uint32(42).fork()).join();
    }
    globalThis.Object.entries(message.languageBehaviors).forEach(([key, value]: [string, LanguageBehavior]) => {
      AgentSettings_LanguageBehaviorsEntry.encode({ key: key as any, value }, writer.uint32(50).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AgentSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgentSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.greeting.push(Greeting.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.personality = Personality.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.role = Role.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.disclaimerMessage.push(DisclaimerMessage.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.rules = Rules.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          const entry6 = AgentSettings_LanguageBehaviorsEntry.decode(reader, reader.uint32());
          if (entry6.value !== undefined) {
            message.languageBehaviors[entry6.key] = entry6.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgentSettings {
    return {
      greeting: globalThis.Array.isArray(object?.greeting) ? object.greeting.map((e: any) => Greeting.fromJSON(e)) : [],
      personality: isSet(object.personality) ? Personality.fromJSON(object.personality) : undefined,
      role: isSet(object.role) ? Role.fromJSON(object.role) : undefined,
      disclaimerMessage: globalThis.Array.isArray(object?.disclaimerMessage)
        ? object.disclaimerMessage.map((e: any) => DisclaimerMessage.fromJSON(e))
        : globalThis.Array.isArray(object?.disclaimer_message)
        ? object.disclaimer_message.map((e: any) => DisclaimerMessage.fromJSON(e))
        : [],
      rules: isSet(object.rules) ? Rules.fromJSON(object.rules) : undefined,
      languageBehaviors: isObject(object.languageBehaviors)
        ? (globalThis.Object.entries(object.languageBehaviors) as [string, any][]).reduce(
          (acc: { [key: string]: LanguageBehavior }, [key, value]: [string, any]) => {
            acc[key] = LanguageBehavior.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.language_behaviors)
        ? (globalThis.Object.entries(object.language_behaviors) as [string, any][]).reduce(
          (acc: { [key: string]: LanguageBehavior }, [key, value]: [string, any]) => {
            acc[key] = LanguageBehavior.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: AgentSettings): unknown {
    const obj: any = {};
    if (message.greeting?.length) {
      obj.greeting = message.greeting.map((e) => Greeting.toJSON(e));
    }
    if (message.personality !== undefined) {
      obj.personality = Personality.toJSON(message.personality);
    }
    if (message.role !== undefined) {
      obj.role = Role.toJSON(message.role);
    }
    if (message.disclaimerMessage?.length) {
      obj.disclaimerMessage = message.disclaimerMessage.map((e) => DisclaimerMessage.toJSON(e));
    }
    if (message.rules !== undefined) {
      obj.rules = Rules.toJSON(message.rules);
    }
    if (message.languageBehaviors) {
      const entries = globalThis.Object.entries(message.languageBehaviors) as [string, LanguageBehavior][];
      if (entries.length > 0) {
        obj.languageBehaviors = {};
        entries.forEach(([k, v]) => {
          obj.languageBehaviors[k] = LanguageBehavior.toJSON(v);
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<AgentSettings>): AgentSettings {
    return AgentSettings.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AgentSettings>): AgentSettings {
    const message = createBaseAgentSettings();
    message.greeting = object.greeting?.map((e) => Greeting.fromPartial(e)) || [];
    message.personality = (object.personality !== undefined && object.personality !== null)
      ? Personality.fromPartial(object.personality)
      : undefined;
    message.role = (object.role !== undefined && object.role !== null) ? Role.fromPartial(object.role) : undefined;
    message.disclaimerMessage = object.disclaimerMessage?.map((e) => DisclaimerMessage.fromPartial(e)) || [];
    message.rules = (object.rules !== undefined && object.rules !== null) ? Rules.fromPartial(object.rules) : undefined;
    message.languageBehaviors =
      (globalThis.Object.entries(object.languageBehaviors ?? {}) as [string, LanguageBehavior][]).reduce(
        (acc: { [key: string]: LanguageBehavior }, [key, value]: [string, LanguageBehavior]) => {
          if (value !== undefined) {
            acc[key] = LanguageBehavior.fromPartial(value);
          }
          return acc;
        },
        {},
      );
    return message;
  },
};

function createBaseAgentSettings_LanguageBehaviorsEntry(): AgentSettings_LanguageBehaviorsEntry {
  return { key: "", value: undefined };
}

export const AgentSettings_LanguageBehaviorsEntry: MessageFns<AgentSettings_LanguageBehaviorsEntry> = {
  encode(message: AgentSettings_LanguageBehaviorsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      LanguageBehavior.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AgentSettings_LanguageBehaviorsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgentSettings_LanguageBehaviorsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = LanguageBehavior.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgentSettings_LanguageBehaviorsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? LanguageBehavior.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: AgentSettings_LanguageBehaviorsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = LanguageBehavior.toJSON(message.value);
    }
    return obj;
  },

  create(base?: DeepPartial<AgentSettings_LanguageBehaviorsEntry>): AgentSettings_LanguageBehaviorsEntry {
    return AgentSettings_LanguageBehaviorsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AgentSettings_LanguageBehaviorsEntry>): AgentSettings_LanguageBehaviorsEntry {
    const message = createBaseAgentSettings_LanguageBehaviorsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? LanguageBehavior.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseGreeting(): Greeting {
  return {
    welcomeMessage: "",
    createdAt: "",
    createdBy: "",
    updatedAt: undefined,
    updatedBy: undefined,
    references: undefined,
    languageCode: "",
  };
}

export const Greeting: MessageFns<Greeting> = {
  encode(message: Greeting, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.welcomeMessage !== "") {
      writer.uint32(10).string(message.welcomeMessage);
    }
    if (message.createdAt !== "") {
      writer.uint32(18).string(message.createdAt);
    }
    if (message.createdBy !== "") {
      writer.uint32(26).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(34).fork()).join();
    }
    if (message.updatedBy !== undefined) {
      writer.uint32(42).string(message.updatedBy);
    }
    if (message.references !== undefined) {
      GreetingReferences.encode(message.references, writer.uint32(50).fork()).join();
    }
    if (message.languageCode !== "") {
      writer.uint32(58).string(message.languageCode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Greeting {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGreeting();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.welcomeMessage = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.createdAt = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.references = GreetingReferences.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.languageCode = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Greeting {
    return {
      welcomeMessage: isSet(object.welcomeMessage)
        ? globalThis.String(object.welcomeMessage)
        : isSet(object.welcome_message)
        ? globalThis.String(object.welcome_message)
        : "",
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
        ? globalThis.String(object.created_at)
        : "",
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : undefined,
      references: isSet(object.references) ? GreetingReferences.fromJSON(object.references) : undefined,
      languageCode: isSet(object.languageCode)
        ? globalThis.String(object.languageCode)
        : isSet(object.language_code)
        ? globalThis.String(object.language_code)
        : "",
    };
  },

  toJSON(message: Greeting): unknown {
    const obj: any = {};
    if (message.welcomeMessage !== "") {
      obj.welcomeMessage = message.welcomeMessage;
    }
    if (message.createdAt !== "") {
      obj.createdAt = message.createdAt;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== undefined) {
      obj.updatedBy = message.updatedBy;
    }
    if (message.references !== undefined) {
      obj.references = GreetingReferences.toJSON(message.references);
    }
    if (message.languageCode !== "") {
      obj.languageCode = message.languageCode;
    }
    return obj;
  },

  create(base?: DeepPartial<Greeting>): Greeting {
    return Greeting.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Greeting>): Greeting {
    const message = createBaseGreeting();
    message.welcomeMessage = object.welcomeMessage ?? "";
    message.createdAt = object.createdAt ?? "";
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? GreetingReferences.fromPartial(object.references)
      : undefined;
    message.languageCode = object.languageCode ?? "";
    return message;
  },
};

function createBaseGreetingUpdateGreeting(): GreetingUpdateGreeting {
  return { welcomeMessage: undefined, references: undefined, languageCode: "" };
}

export const GreetingUpdateGreeting: MessageFns<GreetingUpdateGreeting> = {
  encode(message: GreetingUpdateGreeting, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.welcomeMessage !== undefined) {
      writer.uint32(10).string(message.welcomeMessage);
    }
    if (message.references !== undefined) {
      GreetingReferences.encode(message.references, writer.uint32(18).fork()).join();
    }
    if (message.languageCode !== "") {
      writer.uint32(26).string(message.languageCode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GreetingUpdateGreeting {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGreetingUpdateGreeting();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.welcomeMessage = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.references = GreetingReferences.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.languageCode = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GreetingUpdateGreeting {
    return {
      welcomeMessage: isSet(object.welcomeMessage)
        ? globalThis.String(object.welcomeMessage)
        : isSet(object.welcome_message)
        ? globalThis.String(object.welcome_message)
        : undefined,
      references: isSet(object.references) ? GreetingReferences.fromJSON(object.references) : undefined,
      languageCode: isSet(object.languageCode)
        ? globalThis.String(object.languageCode)
        : isSet(object.language_code)
        ? globalThis.String(object.language_code)
        : "",
    };
  },

  toJSON(message: GreetingUpdateGreeting): unknown {
    const obj: any = {};
    if (message.welcomeMessage !== undefined) {
      obj.welcomeMessage = message.welcomeMessage;
    }
    if (message.references !== undefined) {
      obj.references = GreetingReferences.toJSON(message.references);
    }
    if (message.languageCode !== "") {
      obj.languageCode = message.languageCode;
    }
    return obj;
  },

  create(base?: DeepPartial<GreetingUpdateGreeting>): GreetingUpdateGreeting {
    return GreetingUpdateGreeting.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GreetingUpdateGreeting>): GreetingUpdateGreeting {
    const message = createBaseGreetingUpdateGreeting();
    message.welcomeMessage = object.welcomeMessage ?? undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? GreetingReferences.fromPartial(object.references)
      : undefined;
    message.languageCode = object.languageCode ?? "";
    return message;
  },
};

function createBaseGreetingReferences(): GreetingReferences {
  return { variables: {}, translations: {} };
}

export const GreetingReferences: MessageFns<GreetingReferences> = {
  encode(message: GreetingReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.variables).forEach(([key, value]: [string, boolean]) => {
      GreetingReferences_VariablesEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    globalThis.Object.entries(message.translations).forEach(([key, value]: [string, boolean]) => {
      GreetingReferences_TranslationsEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GreetingReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGreetingReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = GreetingReferences_VariablesEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.variables[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = GreetingReferences_TranslationsEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.translations[entry2.key] = entry2.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GreetingReferences {
    return {
      variables: isObject(object.variables)
        ? (globalThis.Object.entries(object.variables) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      translations: isObject(object.translations)
        ? (globalThis.Object.entries(object.translations) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: GreetingReferences): unknown {
    const obj: any = {};
    if (message.variables) {
      const entries = globalThis.Object.entries(message.variables) as [string, boolean][];
      if (entries.length > 0) {
        obj.variables = {};
        entries.forEach(([k, v]) => {
          obj.variables[k] = v;
        });
      }
    }
    if (message.translations) {
      const entries = globalThis.Object.entries(message.translations) as [string, boolean][];
      if (entries.length > 0) {
        obj.translations = {};
        entries.forEach(([k, v]) => {
          obj.translations[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<GreetingReferences>): GreetingReferences {
    return GreetingReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GreetingReferences>): GreetingReferences {
    const message = createBaseGreetingReferences();
    message.variables = (globalThis.Object.entries(object.variables ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.translations = (globalThis.Object.entries(object.translations ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseGreetingReferences_VariablesEntry(): GreetingReferences_VariablesEntry {
  return { key: "", value: false };
}

export const GreetingReferences_VariablesEntry: MessageFns<GreetingReferences_VariablesEntry> = {
  encode(message: GreetingReferences_VariablesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GreetingReferences_VariablesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGreetingReferences_VariablesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GreetingReferences_VariablesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: GreetingReferences_VariablesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<GreetingReferences_VariablesEntry>): GreetingReferences_VariablesEntry {
    return GreetingReferences_VariablesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GreetingReferences_VariablesEntry>): GreetingReferences_VariablesEntry {
    const message = createBaseGreetingReferences_VariablesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseGreetingReferences_TranslationsEntry(): GreetingReferences_TranslationsEntry {
  return { key: "", value: false };
}

export const GreetingReferences_TranslationsEntry: MessageFns<GreetingReferences_TranslationsEntry> = {
  encode(message: GreetingReferences_TranslationsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GreetingReferences_TranslationsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGreetingReferences_TranslationsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GreetingReferences_TranslationsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: GreetingReferences_TranslationsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<GreetingReferences_TranslationsEntry>): GreetingReferences_TranslationsEntry {
    return GreetingReferences_TranslationsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GreetingReferences_TranslationsEntry>): GreetingReferences_TranslationsEntry {
    const message = createBaseGreetingReferences_TranslationsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseAdjectives(): Adjectives {
  return { values: {} };
}

export const Adjectives: MessageFns<Adjectives> = {
  encode(message: Adjectives, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.values).forEach(([key, value]: [string, boolean]) => {
      Adjectives_ValuesEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Adjectives {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdjectives();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = Adjectives_ValuesEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.values[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Adjectives {
    return {
      values: isObject(object.values)
        ? (globalThis.Object.entries(object.values) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: Adjectives): unknown {
    const obj: any = {};
    if (message.values) {
      const entries = globalThis.Object.entries(message.values) as [string, boolean][];
      if (entries.length > 0) {
        obj.values = {};
        entries.forEach(([k, v]) => {
          obj.values[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<Adjectives>): Adjectives {
    return Adjectives.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Adjectives>): Adjectives {
    const message = createBaseAdjectives();
    message.values = (globalThis.Object.entries(object.values ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseAdjectives_ValuesEntry(): Adjectives_ValuesEntry {
  return { key: "", value: false };
}

export const Adjectives_ValuesEntry: MessageFns<Adjectives_ValuesEntry> = {
  encode(message: Adjectives_ValuesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Adjectives_ValuesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdjectives_ValuesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Adjectives_ValuesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: Adjectives_ValuesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<Adjectives_ValuesEntry>): Adjectives_ValuesEntry {
    return Adjectives_ValuesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Adjectives_ValuesEntry>): Adjectives_ValuesEntry {
    const message = createBaseAdjectives_ValuesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBasePersonality(): Personality {
  return {
    adjectives: {},
    custom: "",
    createdAt: "",
    createdBy: "",
    updatedAt: undefined,
    updatedBy: undefined,
    references: undefined,
  };
}

export const Personality: MessageFns<Personality> = {
  encode(message: Personality, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.adjectives).forEach(([key, value]: [string, boolean]) => {
      Personality_AdjectivesEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    if (message.custom !== "") {
      writer.uint32(18).string(message.custom);
    }
    if (message.createdAt !== "") {
      writer.uint32(26).string(message.createdAt);
    }
    if (message.createdBy !== "") {
      writer.uint32(34).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(42).fork()).join();
    }
    if (message.updatedBy !== undefined) {
      writer.uint32(50).string(message.updatedBy);
    }
    if (message.references !== undefined) {
      PersonalityReferences.encode(message.references, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Personality {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePersonality();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = Personality_AdjectivesEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.adjectives[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.custom = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdAt = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.references = PersonalityReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Personality {
    return {
      adjectives: isObject(object.adjectives)
        ? (globalThis.Object.entries(object.adjectives) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      custom: isSet(object.custom) ? globalThis.String(object.custom) : "",
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
        ? globalThis.String(object.created_at)
        : "",
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : undefined,
      references: isSet(object.references) ? PersonalityReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: Personality): unknown {
    const obj: any = {};
    if (message.adjectives) {
      const entries = globalThis.Object.entries(message.adjectives) as [string, boolean][];
      if (entries.length > 0) {
        obj.adjectives = {};
        entries.forEach(([k, v]) => {
          obj.adjectives[k] = v;
        });
      }
    }
    if (message.custom !== "") {
      obj.custom = message.custom;
    }
    if (message.createdAt !== "") {
      obj.createdAt = message.createdAt;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== undefined) {
      obj.updatedBy = message.updatedBy;
    }
    if (message.references !== undefined) {
      obj.references = PersonalityReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<Personality>): Personality {
    return Personality.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Personality>): Personality {
    const message = createBasePersonality();
    message.adjectives = (globalThis.Object.entries(object.adjectives ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.custom = object.custom ?? "";
    message.createdAt = object.createdAt ?? "";
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? PersonalityReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBasePersonality_AdjectivesEntry(): Personality_AdjectivesEntry {
  return { key: "", value: false };
}

export const Personality_AdjectivesEntry: MessageFns<Personality_AdjectivesEntry> = {
  encode(message: Personality_AdjectivesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Personality_AdjectivesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePersonality_AdjectivesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Personality_AdjectivesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: Personality_AdjectivesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<Personality_AdjectivesEntry>): Personality_AdjectivesEntry {
    return Personality_AdjectivesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Personality_AdjectivesEntry>): Personality_AdjectivesEntry {
    const message = createBasePersonality_AdjectivesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBasePersonalityUpdatePersonality(): PersonalityUpdatePersonality {
  return { adjectives: undefined, custom: undefined, references: undefined };
}

export const PersonalityUpdatePersonality: MessageFns<PersonalityUpdatePersonality> = {
  encode(message: PersonalityUpdatePersonality, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.adjectives !== undefined) {
      Adjectives.encode(message.adjectives, writer.uint32(10).fork()).join();
    }
    if (message.custom !== undefined) {
      writer.uint32(18).string(message.custom);
    }
    if (message.references !== undefined) {
      PersonalityReferences.encode(message.references, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PersonalityUpdatePersonality {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePersonalityUpdatePersonality();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.adjectives = Adjectives.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.custom = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.references = PersonalityReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PersonalityUpdatePersonality {
    return {
      adjectives: isSet(object.adjectives) ? Adjectives.fromJSON(object.adjectives) : undefined,
      custom: isSet(object.custom) ? globalThis.String(object.custom) : undefined,
      references: isSet(object.references) ? PersonalityReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: PersonalityUpdatePersonality): unknown {
    const obj: any = {};
    if (message.adjectives !== undefined) {
      obj.adjectives = Adjectives.toJSON(message.adjectives);
    }
    if (message.custom !== undefined) {
      obj.custom = message.custom;
    }
    if (message.references !== undefined) {
      obj.references = PersonalityReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<PersonalityUpdatePersonality>): PersonalityUpdatePersonality {
    return PersonalityUpdatePersonality.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PersonalityUpdatePersonality>): PersonalityUpdatePersonality {
    const message = createBasePersonalityUpdatePersonality();
    message.adjectives = (object.adjectives !== undefined && object.adjectives !== null)
      ? Adjectives.fromPartial(object.adjectives)
      : undefined;
    message.custom = object.custom ?? undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? PersonalityReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBasePersonalityReferences(): PersonalityReferences {
  return { variables: {} };
}

export const PersonalityReferences: MessageFns<PersonalityReferences> = {
  encode(message: PersonalityReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.variables).forEach(([key, value]: [string, boolean]) => {
      PersonalityReferences_VariablesEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PersonalityReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePersonalityReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = PersonalityReferences_VariablesEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.variables[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PersonalityReferences {
    return {
      variables: isObject(object.variables)
        ? (globalThis.Object.entries(object.variables) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: PersonalityReferences): unknown {
    const obj: any = {};
    if (message.variables) {
      const entries = globalThis.Object.entries(message.variables) as [string, boolean][];
      if (entries.length > 0) {
        obj.variables = {};
        entries.forEach(([k, v]) => {
          obj.variables[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<PersonalityReferences>): PersonalityReferences {
    return PersonalityReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PersonalityReferences>): PersonalityReferences {
    const message = createBasePersonalityReferences();
    message.variables = (globalThis.Object.entries(object.variables ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBasePersonalityReferences_VariablesEntry(): PersonalityReferences_VariablesEntry {
  return { key: "", value: false };
}

export const PersonalityReferences_VariablesEntry: MessageFns<PersonalityReferences_VariablesEntry> = {
  encode(message: PersonalityReferences_VariablesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PersonalityReferences_VariablesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePersonalityReferences_VariablesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PersonalityReferences_VariablesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: PersonalityReferences_VariablesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<PersonalityReferences_VariablesEntry>): PersonalityReferences_VariablesEntry {
    return PersonalityReferences_VariablesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PersonalityReferences_VariablesEntry>): PersonalityReferences_VariablesEntry {
    const message = createBasePersonalityReferences_VariablesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseRole(): Role {
  return {
    value: "",
    additionalInfo: "",
    custom: "",
    createdAt: "",
    createdBy: "",
    updatedAt: undefined,
    updatedBy: undefined,
    references: undefined,
  };
}

export const Role: MessageFns<Role> = {
  encode(message: Role, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.value !== "") {
      writer.uint32(10).string(message.value);
    }
    if (message.additionalInfo !== "") {
      writer.uint32(18).string(message.additionalInfo);
    }
    if (message.custom !== "") {
      writer.uint32(26).string(message.custom);
    }
    if (message.createdAt !== "") {
      writer.uint32(34).string(message.createdAt);
    }
    if (message.createdBy !== "") {
      writer.uint32(42).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(50).fork()).join();
    }
    if (message.updatedBy !== undefined) {
      writer.uint32(58).string(message.updatedBy);
    }
    if (message.references !== undefined) {
      RoleReferences.encode(message.references, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Role {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRole();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.value = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.additionalInfo = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.custom = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.references = RoleReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Role {
    return {
      value: isSet(object.value) ? globalThis.String(object.value) : "",
      additionalInfo: isSet(object.additionalInfo)
        ? globalThis.String(object.additionalInfo)
        : isSet(object.additional_info)
        ? globalThis.String(object.additional_info)
        : "",
      custom: isSet(object.custom) ? globalThis.String(object.custom) : "",
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
        ? globalThis.String(object.created_at)
        : "",
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : undefined,
      references: isSet(object.references) ? RoleReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: Role): unknown {
    const obj: any = {};
    if (message.value !== "") {
      obj.value = message.value;
    }
    if (message.additionalInfo !== "") {
      obj.additionalInfo = message.additionalInfo;
    }
    if (message.custom !== "") {
      obj.custom = message.custom;
    }
    if (message.createdAt !== "") {
      obj.createdAt = message.createdAt;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== undefined) {
      obj.updatedBy = message.updatedBy;
    }
    if (message.references !== undefined) {
      obj.references = RoleReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<Role>): Role {
    return Role.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Role>): Role {
    const message = createBaseRole();
    message.value = object.value ?? "";
    message.additionalInfo = object.additionalInfo ?? "";
    message.custom = object.custom ?? "";
    message.createdAt = object.createdAt ?? "";
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? RoleReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseRoleUpdateRole(): RoleUpdateRole {
  return { value: undefined, additionalInfo: undefined, custom: undefined, references: undefined };
}

export const RoleUpdateRole: MessageFns<RoleUpdateRole> = {
  encode(message: RoleUpdateRole, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.value !== undefined) {
      writer.uint32(10).string(message.value);
    }
    if (message.additionalInfo !== undefined) {
      writer.uint32(18).string(message.additionalInfo);
    }
    if (message.custom !== undefined) {
      writer.uint32(26).string(message.custom);
    }
    if (message.references !== undefined) {
      RoleReferences.encode(message.references, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RoleUpdateRole {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoleUpdateRole();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.value = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.additionalInfo = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.custom = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.references = RoleReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RoleUpdateRole {
    return {
      value: isSet(object.value) ? globalThis.String(object.value) : undefined,
      additionalInfo: isSet(object.additionalInfo)
        ? globalThis.String(object.additionalInfo)
        : isSet(object.additional_info)
        ? globalThis.String(object.additional_info)
        : undefined,
      custom: isSet(object.custom) ? globalThis.String(object.custom) : undefined,
      references: isSet(object.references) ? RoleReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: RoleUpdateRole): unknown {
    const obj: any = {};
    if (message.value !== undefined) {
      obj.value = message.value;
    }
    if (message.additionalInfo !== undefined) {
      obj.additionalInfo = message.additionalInfo;
    }
    if (message.custom !== undefined) {
      obj.custom = message.custom;
    }
    if (message.references !== undefined) {
      obj.references = RoleReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<RoleUpdateRole>): RoleUpdateRole {
    return RoleUpdateRole.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RoleUpdateRole>): RoleUpdateRole {
    const message = createBaseRoleUpdateRole();
    message.value = object.value ?? undefined;
    message.additionalInfo = object.additionalInfo ?? undefined;
    message.custom = object.custom ?? undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? RoleReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseRoleReferences(): RoleReferences {
  return { variables: {} };
}

export const RoleReferences: MessageFns<RoleReferences> = {
  encode(message: RoleReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.variables).forEach(([key, value]: [string, boolean]) => {
      RoleReferences_VariablesEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RoleReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoleReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = RoleReferences_VariablesEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.variables[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RoleReferences {
    return {
      variables: isObject(object.variables)
        ? (globalThis.Object.entries(object.variables) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: RoleReferences): unknown {
    const obj: any = {};
    if (message.variables) {
      const entries = globalThis.Object.entries(message.variables) as [string, boolean][];
      if (entries.length > 0) {
        obj.variables = {};
        entries.forEach(([k, v]) => {
          obj.variables[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<RoleReferences>): RoleReferences {
    return RoleReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RoleReferences>): RoleReferences {
    const message = createBaseRoleReferences();
    message.variables = (globalThis.Object.entries(object.variables ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseRoleReferences_VariablesEntry(): RoleReferences_VariablesEntry {
  return { key: "", value: false };
}

export const RoleReferences_VariablesEntry: MessageFns<RoleReferences_VariablesEntry> = {
  encode(message: RoleReferences_VariablesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RoleReferences_VariablesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoleReferences_VariablesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RoleReferences_VariablesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: RoleReferences_VariablesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<RoleReferences_VariablesEntry>): RoleReferences_VariablesEntry {
    return RoleReferences_VariablesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RoleReferences_VariablesEntry>): RoleReferences_VariablesEntry {
    const message = createBaseRoleReferences_VariablesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseDisclaimerMessageReferences(): DisclaimerMessageReferences {
  return { translations: {} };
}

export const DisclaimerMessageReferences: MessageFns<DisclaimerMessageReferences> = {
  encode(message: DisclaimerMessageReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.translations).forEach(([key, value]: [string, boolean]) => {
      DisclaimerMessageReferences_TranslationsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DisclaimerMessageReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDisclaimerMessageReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = DisclaimerMessageReferences_TranslationsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.translations[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DisclaimerMessageReferences {
    return {
      translations: isObject(object.translations)
        ? (globalThis.Object.entries(object.translations) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: DisclaimerMessageReferences): unknown {
    const obj: any = {};
    if (message.translations) {
      const entries = globalThis.Object.entries(message.translations) as [string, boolean][];
      if (entries.length > 0) {
        obj.translations = {};
        entries.forEach(([k, v]) => {
          obj.translations[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<DisclaimerMessageReferences>): DisclaimerMessageReferences {
    return DisclaimerMessageReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DisclaimerMessageReferences>): DisclaimerMessageReferences {
    const message = createBaseDisclaimerMessageReferences();
    message.translations = (globalThis.Object.entries(object.translations ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseDisclaimerMessageReferences_TranslationsEntry(): DisclaimerMessageReferences_TranslationsEntry {
  return { key: "", value: false };
}

export const DisclaimerMessageReferences_TranslationsEntry: MessageFns<DisclaimerMessageReferences_TranslationsEntry> =
  {
    encode(
      message: DisclaimerMessageReferences_TranslationsEntry,
      writer: BinaryWriter = new BinaryWriter(),
    ): BinaryWriter {
      if (message.key !== "") {
        writer.uint32(10).string(message.key);
      }
      if (message.value !== false) {
        writer.uint32(16).bool(message.value);
      }
      return writer;
    },

    decode(input: BinaryReader | Uint8Array, length?: number): DisclaimerMessageReferences_TranslationsEntry {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDisclaimerMessageReferences_TranslationsEntry();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.key = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.value = reader.bool();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    },

    fromJSON(object: any): DisclaimerMessageReferences_TranslationsEntry {
      return {
        key: isSet(object.key) ? globalThis.String(object.key) : "",
        value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
      };
    },

    toJSON(message: DisclaimerMessageReferences_TranslationsEntry): unknown {
      const obj: any = {};
      if (message.key !== "") {
        obj.key = message.key;
      }
      if (message.value !== false) {
        obj.value = message.value;
      }
      return obj;
    },

    create(
      base?: DeepPartial<DisclaimerMessageReferences_TranslationsEntry>,
    ): DisclaimerMessageReferences_TranslationsEntry {
      return DisclaimerMessageReferences_TranslationsEntry.fromPartial(base ?? {});
    },
    fromPartial(
      object: DeepPartial<DisclaimerMessageReferences_TranslationsEntry>,
    ): DisclaimerMessageReferences_TranslationsEntry {
      const message = createBaseDisclaimerMessageReferences_TranslationsEntry();
      message.key = object.key ?? "";
      message.value = object.value ?? false;
      return message;
    },
  };

function createBaseDisclaimerMessage(): DisclaimerMessage {
  return {
    isEnabled: false,
    message: "",
    ringingTone: undefined,
    createdAt: "",
    createdBy: "",
    updatedAt: undefined,
    updatedBy: undefined,
    languageCode: "",
    references: undefined,
  };
}

export const DisclaimerMessage: MessageFns<DisclaimerMessage> = {
  encode(message: DisclaimerMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.isEnabled !== false) {
      writer.uint32(8).bool(message.isEnabled);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    if (message.ringingTone !== undefined) {
      AudioToPlay.encode(message.ringingTone, writer.uint32(26).fork()).join();
    }
    if (message.createdAt !== "") {
      writer.uint32(34).string(message.createdAt);
    }
    if (message.createdBy !== "") {
      writer.uint32(42).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(50).fork()).join();
    }
    if (message.updatedBy !== undefined) {
      writer.uint32(58).string(message.updatedBy);
    }
    if (message.languageCode !== "") {
      writer.uint32(66).string(message.languageCode);
    }
    if (message.references !== undefined) {
      DisclaimerMessageReferences.encode(message.references, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DisclaimerMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDisclaimerMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.isEnabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ringingTone = AudioToPlay.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.languageCode = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.references = DisclaimerMessageReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DisclaimerMessage {
    return {
      isEnabled: isSet(object.isEnabled)
        ? globalThis.Boolean(object.isEnabled)
        : isSet(object.is_enabled)
        ? globalThis.Boolean(object.is_enabled)
        : false,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      ringingTone: isSet(object.ringingTone)
        ? AudioToPlay.fromJSON(object.ringingTone)
        : isSet(object.ringing_tone)
        ? AudioToPlay.fromJSON(object.ringing_tone)
        : undefined,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
        ? globalThis.String(object.created_at)
        : "",
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : undefined,
      languageCode: isSet(object.languageCode)
        ? globalThis.String(object.languageCode)
        : isSet(object.language_code)
        ? globalThis.String(object.language_code)
        : "",
      references: isSet(object.references) ? DisclaimerMessageReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: DisclaimerMessage): unknown {
    const obj: any = {};
    if (message.isEnabled !== false) {
      obj.isEnabled = message.isEnabled;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.ringingTone !== undefined) {
      obj.ringingTone = AudioToPlay.toJSON(message.ringingTone);
    }
    if (message.createdAt !== "") {
      obj.createdAt = message.createdAt;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== undefined) {
      obj.updatedBy = message.updatedBy;
    }
    if (message.languageCode !== "") {
      obj.languageCode = message.languageCode;
    }
    if (message.references !== undefined) {
      obj.references = DisclaimerMessageReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<DisclaimerMessage>): DisclaimerMessage {
    return DisclaimerMessage.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DisclaimerMessage>): DisclaimerMessage {
    const message = createBaseDisclaimerMessage();
    message.isEnabled = object.isEnabled ?? false;
    message.message = object.message ?? "";
    message.ringingTone = (object.ringingTone !== undefined && object.ringingTone !== null)
      ? AudioToPlay.fromPartial(object.ringingTone)
      : undefined;
    message.createdAt = object.createdAt ?? "";
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? undefined;
    message.languageCode = object.languageCode ?? "";
    message.references = (object.references !== undefined && object.references !== null)
      ? DisclaimerMessageReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseDisclaimerMessageUpdateDisclaimerMessage(): DisclaimerMessageUpdateDisclaimerMessage {
  return { isEnabled: undefined, message: undefined, ringingTone: undefined, languageCode: "", references: undefined };
}

export const DisclaimerMessageUpdateDisclaimerMessage: MessageFns<DisclaimerMessageUpdateDisclaimerMessage> = {
  encode(message: DisclaimerMessageUpdateDisclaimerMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.isEnabled !== undefined) {
      writer.uint32(8).bool(message.isEnabled);
    }
    if (message.message !== undefined) {
      writer.uint32(18).string(message.message);
    }
    if (message.ringingTone !== undefined) {
      UpdateRingingTone.encode(message.ringingTone, writer.uint32(26).fork()).join();
    }
    if (message.languageCode !== "") {
      writer.uint32(34).string(message.languageCode);
    }
    if (message.references !== undefined) {
      DisclaimerMessageReferences.encode(message.references, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DisclaimerMessageUpdateDisclaimerMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDisclaimerMessageUpdateDisclaimerMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.isEnabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ringingTone = UpdateRingingTone.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.languageCode = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.references = DisclaimerMessageReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DisclaimerMessageUpdateDisclaimerMessage {
    return {
      isEnabled: isSet(object.isEnabled)
        ? globalThis.Boolean(object.isEnabled)
        : isSet(object.is_enabled)
        ? globalThis.Boolean(object.is_enabled)
        : undefined,
      message: isSet(object.message) ? globalThis.String(object.message) : undefined,
      ringingTone: isSet(object.ringingTone)
        ? UpdateRingingTone.fromJSON(object.ringingTone)
        : isSet(object.ringing_tone)
        ? UpdateRingingTone.fromJSON(object.ringing_tone)
        : undefined,
      languageCode: isSet(object.languageCode)
        ? globalThis.String(object.languageCode)
        : isSet(object.language_code)
        ? globalThis.String(object.language_code)
        : "",
      references: isSet(object.references) ? DisclaimerMessageReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: DisclaimerMessageUpdateDisclaimerMessage): unknown {
    const obj: any = {};
    if (message.isEnabled !== undefined) {
      obj.isEnabled = message.isEnabled;
    }
    if (message.message !== undefined) {
      obj.message = message.message;
    }
    if (message.ringingTone !== undefined) {
      obj.ringingTone = UpdateRingingTone.toJSON(message.ringingTone);
    }
    if (message.languageCode !== "") {
      obj.languageCode = message.languageCode;
    }
    if (message.references !== undefined) {
      obj.references = DisclaimerMessageReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<DisclaimerMessageUpdateDisclaimerMessage>): DisclaimerMessageUpdateDisclaimerMessage {
    return DisclaimerMessageUpdateDisclaimerMessage.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DisclaimerMessageUpdateDisclaimerMessage>): DisclaimerMessageUpdateDisclaimerMessage {
    const message = createBaseDisclaimerMessageUpdateDisclaimerMessage();
    message.isEnabled = object.isEnabled ?? undefined;
    message.message = object.message ?? undefined;
    message.ringingTone = (object.ringingTone !== undefined && object.ringingTone !== null)
      ? UpdateRingingTone.fromPartial(object.ringingTone)
      : undefined;
    message.languageCode = object.languageCode ?? "";
    message.references = (object.references !== undefined && object.references !== null)
      ? DisclaimerMessageReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseUpdateRingingTone(): UpdateRingingTone {
  return { s3Path: undefined, originalFilename: undefined, publicUrl: undefined };
}

export const UpdateRingingTone: MessageFns<UpdateRingingTone> = {
  encode(message: UpdateRingingTone, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.s3Path !== undefined) {
      writer.uint32(10).string(message.s3Path);
    }
    if (message.originalFilename !== undefined) {
      writer.uint32(18).string(message.originalFilename);
    }
    if (message.publicUrl !== undefined) {
      writer.uint32(26).string(message.publicUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateRingingTone {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateRingingTone();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.s3Path = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.originalFilename = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.publicUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateRingingTone {
    return {
      s3Path: isSet(object.s3Path)
        ? globalThis.String(object.s3Path)
        : isSet(object.s3_path)
        ? globalThis.String(object.s3_path)
        : undefined,
      originalFilename: isSet(object.originalFilename)
        ? globalThis.String(object.originalFilename)
        : isSet(object.original_filename)
        ? globalThis.String(object.original_filename)
        : undefined,
      publicUrl: isSet(object.publicUrl)
        ? globalThis.String(object.publicUrl)
        : isSet(object.public_url)
        ? globalThis.String(object.public_url)
        : undefined,
    };
  },

  toJSON(message: UpdateRingingTone): unknown {
    const obj: any = {};
    if (message.s3Path !== undefined) {
      obj.s3Path = message.s3Path;
    }
    if (message.originalFilename !== undefined) {
      obj.originalFilename = message.originalFilename;
    }
    if (message.publicUrl !== undefined) {
      obj.publicUrl = message.publicUrl;
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateRingingTone>): UpdateRingingTone {
    return UpdateRingingTone.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateRingingTone>): UpdateRingingTone {
    const message = createBaseUpdateRingingTone();
    message.s3Path = object.s3Path ?? undefined;
    message.originalFilename = object.originalFilename ?? undefined;
    message.publicUrl = object.publicUrl ?? undefined;
    return message;
  },
};

function createBaseAudioToPlay(): AudioToPlay {
  return { s3Path: "", originalFilename: "", publicUrl: "" };
}

export const AudioToPlay: MessageFns<AudioToPlay> = {
  encode(message: AudioToPlay, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.s3Path !== "") {
      writer.uint32(10).string(message.s3Path);
    }
    if (message.originalFilename !== "") {
      writer.uint32(18).string(message.originalFilename);
    }
    if (message.publicUrl !== "") {
      writer.uint32(26).string(message.publicUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AudioToPlay {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAudioToPlay();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.s3Path = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.originalFilename = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.publicUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AudioToPlay {
    return {
      s3Path: isSet(object.s3Path)
        ? globalThis.String(object.s3Path)
        : isSet(object.s3_path)
        ? globalThis.String(object.s3_path)
        : "",
      originalFilename: isSet(object.originalFilename)
        ? globalThis.String(object.originalFilename)
        : isSet(object.original_filename)
        ? globalThis.String(object.original_filename)
        : "",
      publicUrl: isSet(object.publicUrl)
        ? globalThis.String(object.publicUrl)
        : isSet(object.public_url)
        ? globalThis.String(object.public_url)
        : "",
    };
  },

  toJSON(message: AudioToPlay): unknown {
    const obj: any = {};
    if (message.s3Path !== "") {
      obj.s3Path = message.s3Path;
    }
    if (message.originalFilename !== "") {
      obj.originalFilename = message.originalFilename;
    }
    if (message.publicUrl !== "") {
      obj.publicUrl = message.publicUrl;
    }
    return obj;
  },

  create(base?: DeepPartial<AudioToPlay>): AudioToPlay {
    return AudioToPlay.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AudioToPlay>): AudioToPlay {
    const message = createBaseAudioToPlay();
    message.s3Path = object.s3Path ?? "";
    message.originalFilename = object.originalFilename ?? "";
    message.publicUrl = object.publicUrl ?? "";
    return message;
  },
};

function createBaseRulesReferences(): RulesReferences {
  return { sms: {}, handoff: {}, attributes: {}, globalFunctions: {}, variables: {}, translations: {} };
}

export const RulesReferences: MessageFns<RulesReferences> = {
  encode(message: RulesReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.sms).forEach(([key, value]: [string, boolean]) => {
      RulesReferences_SmsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    globalThis.Object.entries(message.handoff).forEach(([key, value]: [string, boolean]) => {
      RulesReferences_HandoffEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    globalThis.Object.entries(message.attributes).forEach(([key, value]: [string, boolean]) => {
      RulesReferences_AttributesEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).join();
    });
    globalThis.Object.entries(message.globalFunctions).forEach(([key, value]: [string, boolean]) => {
      RulesReferences_GlobalFunctionsEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    globalThis.Object.entries(message.variables).forEach(([key, value]: [string, boolean]) => {
      RulesReferences_VariablesEntry.encode({ key: key as any, value }, writer.uint32(42).fork()).join();
    });
    globalThis.Object.entries(message.translations).forEach(([key, value]: [string, boolean]) => {
      RulesReferences_TranslationsEntry.encode({ key: key as any, value }, writer.uint32(50).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RulesReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRulesReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = RulesReferences_SmsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.sms[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = RulesReferences_HandoffEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.handoff[entry2.key] = entry2.value;
          }
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          const entry3 = RulesReferences_AttributesEntry.decode(reader, reader.uint32());
          if (entry3.value !== undefined) {
            message.attributes[entry3.key] = entry3.value;
          }
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = RulesReferences_GlobalFunctionsEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.globalFunctions[entry4.key] = entry4.value;
          }
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = RulesReferences_VariablesEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.variables[entry5.key] = entry5.value;
          }
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          const entry6 = RulesReferences_TranslationsEntry.decode(reader, reader.uint32());
          if (entry6.value !== undefined) {
            message.translations[entry6.key] = entry6.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RulesReferences {
    return {
      sms: isObject(object.sms)
        ? (globalThis.Object.entries(object.sms) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      handoff: isObject(object.handoff)
        ? (globalThis.Object.entries(object.handoff) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      attributes: isObject(object.attributes)
        ? (globalThis.Object.entries(object.attributes) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      globalFunctions: isObject(object.globalFunctions)
        ? (globalThis.Object.entries(object.globalFunctions) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      variables: isObject(object.variables)
        ? (globalThis.Object.entries(object.variables) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      translations: isObject(object.translations)
        ? (globalThis.Object.entries(object.translations) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: RulesReferences): unknown {
    const obj: any = {};
    if (message.sms) {
      const entries = globalThis.Object.entries(message.sms) as [string, boolean][];
      if (entries.length > 0) {
        obj.sms = {};
        entries.forEach(([k, v]) => {
          obj.sms[k] = v;
        });
      }
    }
    if (message.handoff) {
      const entries = globalThis.Object.entries(message.handoff) as [string, boolean][];
      if (entries.length > 0) {
        obj.handoff = {};
        entries.forEach(([k, v]) => {
          obj.handoff[k] = v;
        });
      }
    }
    if (message.attributes) {
      const entries = globalThis.Object.entries(message.attributes) as [string, boolean][];
      if (entries.length > 0) {
        obj.attributes = {};
        entries.forEach(([k, v]) => {
          obj.attributes[k] = v;
        });
      }
    }
    if (message.globalFunctions) {
      const entries = globalThis.Object.entries(message.globalFunctions) as [string, boolean][];
      if (entries.length > 0) {
        obj.globalFunctions = {};
        entries.forEach(([k, v]) => {
          obj.globalFunctions[k] = v;
        });
      }
    }
    if (message.variables) {
      const entries = globalThis.Object.entries(message.variables) as [string, boolean][];
      if (entries.length > 0) {
        obj.variables = {};
        entries.forEach(([k, v]) => {
          obj.variables[k] = v;
        });
      }
    }
    if (message.translations) {
      const entries = globalThis.Object.entries(message.translations) as [string, boolean][];
      if (entries.length > 0) {
        obj.translations = {};
        entries.forEach(([k, v]) => {
          obj.translations[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<RulesReferences>): RulesReferences {
    return RulesReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RulesReferences>): RulesReferences {
    const message = createBaseRulesReferences();
    message.sms = (globalThis.Object.entries(object.sms ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.handoff = (globalThis.Object.entries(object.handoff ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.attributes = (globalThis.Object.entries(object.attributes ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.globalFunctions = (globalThis.Object.entries(object.globalFunctions ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.variables = (globalThis.Object.entries(object.variables ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.translations = (globalThis.Object.entries(object.translations ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseRulesReferences_SmsEntry(): RulesReferences_SmsEntry {
  return { key: "", value: false };
}

export const RulesReferences_SmsEntry: MessageFns<RulesReferences_SmsEntry> = {
  encode(message: RulesReferences_SmsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RulesReferences_SmsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRulesReferences_SmsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RulesReferences_SmsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: RulesReferences_SmsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<RulesReferences_SmsEntry>): RulesReferences_SmsEntry {
    return RulesReferences_SmsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RulesReferences_SmsEntry>): RulesReferences_SmsEntry {
    const message = createBaseRulesReferences_SmsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseRulesReferences_HandoffEntry(): RulesReferences_HandoffEntry {
  return { key: "", value: false };
}

export const RulesReferences_HandoffEntry: MessageFns<RulesReferences_HandoffEntry> = {
  encode(message: RulesReferences_HandoffEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RulesReferences_HandoffEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRulesReferences_HandoffEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RulesReferences_HandoffEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: RulesReferences_HandoffEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<RulesReferences_HandoffEntry>): RulesReferences_HandoffEntry {
    return RulesReferences_HandoffEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RulesReferences_HandoffEntry>): RulesReferences_HandoffEntry {
    const message = createBaseRulesReferences_HandoffEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseRulesReferences_AttributesEntry(): RulesReferences_AttributesEntry {
  return { key: "", value: false };
}

export const RulesReferences_AttributesEntry: MessageFns<RulesReferences_AttributesEntry> = {
  encode(message: RulesReferences_AttributesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RulesReferences_AttributesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRulesReferences_AttributesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RulesReferences_AttributesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: RulesReferences_AttributesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<RulesReferences_AttributesEntry>): RulesReferences_AttributesEntry {
    return RulesReferences_AttributesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RulesReferences_AttributesEntry>): RulesReferences_AttributesEntry {
    const message = createBaseRulesReferences_AttributesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseRulesReferences_GlobalFunctionsEntry(): RulesReferences_GlobalFunctionsEntry {
  return { key: "", value: false };
}

export const RulesReferences_GlobalFunctionsEntry: MessageFns<RulesReferences_GlobalFunctionsEntry> = {
  encode(message: RulesReferences_GlobalFunctionsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RulesReferences_GlobalFunctionsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRulesReferences_GlobalFunctionsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RulesReferences_GlobalFunctionsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: RulesReferences_GlobalFunctionsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<RulesReferences_GlobalFunctionsEntry>): RulesReferences_GlobalFunctionsEntry {
    return RulesReferences_GlobalFunctionsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RulesReferences_GlobalFunctionsEntry>): RulesReferences_GlobalFunctionsEntry {
    const message = createBaseRulesReferences_GlobalFunctionsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseRulesReferences_VariablesEntry(): RulesReferences_VariablesEntry {
  return { key: "", value: false };
}

export const RulesReferences_VariablesEntry: MessageFns<RulesReferences_VariablesEntry> = {
  encode(message: RulesReferences_VariablesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RulesReferences_VariablesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRulesReferences_VariablesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RulesReferences_VariablesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: RulesReferences_VariablesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<RulesReferences_VariablesEntry>): RulesReferences_VariablesEntry {
    return RulesReferences_VariablesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RulesReferences_VariablesEntry>): RulesReferences_VariablesEntry {
    const message = createBaseRulesReferences_VariablesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseRulesReferences_TranslationsEntry(): RulesReferences_TranslationsEntry {
  return { key: "", value: false };
}

export const RulesReferences_TranslationsEntry: MessageFns<RulesReferences_TranslationsEntry> = {
  encode(message: RulesReferences_TranslationsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RulesReferences_TranslationsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRulesReferences_TranslationsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RulesReferences_TranslationsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: RulesReferences_TranslationsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<RulesReferences_TranslationsEntry>): RulesReferences_TranslationsEntry {
    return RulesReferences_TranslationsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RulesReferences_TranslationsEntry>): RulesReferences_TranslationsEntry {
    const message = createBaseRulesReferences_TranslationsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseRules(): Rules {
  return {
    behaviour: "",
    references: undefined,
    createdAt: "",
    createdBy: "",
    updatedAt: undefined,
    updatedBy: undefined,
  };
}

export const Rules: MessageFns<Rules> = {
  encode(message: Rules, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.behaviour !== "") {
      writer.uint32(10).string(message.behaviour);
    }
    if (message.references !== undefined) {
      RulesReferences.encode(message.references, writer.uint32(18).fork()).join();
    }
    if (message.createdAt !== "") {
      writer.uint32(26).string(message.createdAt);
    }
    if (message.createdBy !== "") {
      writer.uint32(34).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(42).fork()).join();
    }
    if (message.updatedBy !== undefined) {
      writer.uint32(50).string(message.updatedBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Rules {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRules();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.behaviour = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.references = RulesReferences.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdAt = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Rules {
    return {
      behaviour: isSet(object.behaviour) ? globalThis.String(object.behaviour) : "",
      references: isSet(object.references) ? RulesReferences.fromJSON(object.references) : undefined,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
        ? globalThis.String(object.created_at)
        : "",
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : undefined,
    };
  },

  toJSON(message: Rules): unknown {
    const obj: any = {};
    if (message.behaviour !== "") {
      obj.behaviour = message.behaviour;
    }
    if (message.references !== undefined) {
      obj.references = RulesReferences.toJSON(message.references);
    }
    if (message.createdAt !== "") {
      obj.createdAt = message.createdAt;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== undefined) {
      obj.updatedBy = message.updatedBy;
    }
    return obj;
  },

  create(base?: DeepPartial<Rules>): Rules {
    return Rules.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Rules>): Rules {
    const message = createBaseRules();
    message.behaviour = object.behaviour ?? "";
    message.references = (object.references !== undefined && object.references !== null)
      ? RulesReferences.fromPartial(object.references)
      : undefined;
    message.createdAt = object.createdAt ?? "";
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? undefined;
    return message;
  },
};

function createBaseRulesUpdateRules(): RulesUpdateRules {
  return { behaviour: undefined, references: undefined };
}

export const RulesUpdateRules: MessageFns<RulesUpdateRules> = {
  encode(message: RulesUpdateRules, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.behaviour !== undefined) {
      writer.uint32(10).string(message.behaviour);
    }
    if (message.references !== undefined) {
      RulesReferences.encode(message.references, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RulesUpdateRules {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRulesUpdateRules();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.behaviour = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.references = RulesReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RulesUpdateRules {
    return {
      behaviour: isSet(object.behaviour) ? globalThis.String(object.behaviour) : undefined,
      references: isSet(object.references) ? RulesReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: RulesUpdateRules): unknown {
    const obj: any = {};
    if (message.behaviour !== undefined) {
      obj.behaviour = message.behaviour;
    }
    if (message.references !== undefined) {
      obj.references = RulesReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<RulesUpdateRules>): RulesUpdateRules {
    return RulesUpdateRules.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RulesUpdateRules>): RulesUpdateRules {
    const message = createBaseRulesUpdateRules();
    message.behaviour = object.behaviour ?? undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? RulesReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseLanguageBehaviorReferences(): LanguageBehaviorReferences {
  return { sms: {}, handoff: {}, attributes: {}, globalFunctions: {}, variables: {} };
}

export const LanguageBehaviorReferences: MessageFns<LanguageBehaviorReferences> = {
  encode(message: LanguageBehaviorReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.sms).forEach(([key, value]: [string, boolean]) => {
      LanguageBehaviorReferences_SmsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    globalThis.Object.entries(message.handoff).forEach(([key, value]: [string, boolean]) => {
      LanguageBehaviorReferences_HandoffEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    globalThis.Object.entries(message.attributes).forEach(([key, value]: [string, boolean]) => {
      LanguageBehaviorReferences_AttributesEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).join();
    });
    globalThis.Object.entries(message.globalFunctions).forEach(([key, value]: [string, boolean]) => {
      LanguageBehaviorReferences_GlobalFunctionsEntry.encode({ key: key as any, value }, writer.uint32(34).fork())
        .join();
    });
    globalThis.Object.entries(message.variables).forEach(([key, value]: [string, boolean]) => {
      LanguageBehaviorReferences_VariablesEntry.encode({ key: key as any, value }, writer.uint32(42).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LanguageBehaviorReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLanguageBehaviorReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = LanguageBehaviorReferences_SmsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.sms[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = LanguageBehaviorReferences_HandoffEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.handoff[entry2.key] = entry2.value;
          }
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          const entry3 = LanguageBehaviorReferences_AttributesEntry.decode(reader, reader.uint32());
          if (entry3.value !== undefined) {
            message.attributes[entry3.key] = entry3.value;
          }
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = LanguageBehaviorReferences_GlobalFunctionsEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.globalFunctions[entry4.key] = entry4.value;
          }
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = LanguageBehaviorReferences_VariablesEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.variables[entry5.key] = entry5.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LanguageBehaviorReferences {
    return {
      sms: isObject(object.sms)
        ? (globalThis.Object.entries(object.sms) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      handoff: isObject(object.handoff)
        ? (globalThis.Object.entries(object.handoff) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      attributes: isObject(object.attributes)
        ? (globalThis.Object.entries(object.attributes) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      globalFunctions: isObject(object.globalFunctions)
        ? (globalThis.Object.entries(object.globalFunctions) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      variables: isObject(object.variables)
        ? (globalThis.Object.entries(object.variables) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: LanguageBehaviorReferences): unknown {
    const obj: any = {};
    if (message.sms) {
      const entries = globalThis.Object.entries(message.sms) as [string, boolean][];
      if (entries.length > 0) {
        obj.sms = {};
        entries.forEach(([k, v]) => {
          obj.sms[k] = v;
        });
      }
    }
    if (message.handoff) {
      const entries = globalThis.Object.entries(message.handoff) as [string, boolean][];
      if (entries.length > 0) {
        obj.handoff = {};
        entries.forEach(([k, v]) => {
          obj.handoff[k] = v;
        });
      }
    }
    if (message.attributes) {
      const entries = globalThis.Object.entries(message.attributes) as [string, boolean][];
      if (entries.length > 0) {
        obj.attributes = {};
        entries.forEach(([k, v]) => {
          obj.attributes[k] = v;
        });
      }
    }
    if (message.globalFunctions) {
      const entries = globalThis.Object.entries(message.globalFunctions) as [string, boolean][];
      if (entries.length > 0) {
        obj.globalFunctions = {};
        entries.forEach(([k, v]) => {
          obj.globalFunctions[k] = v;
        });
      }
    }
    if (message.variables) {
      const entries = globalThis.Object.entries(message.variables) as [string, boolean][];
      if (entries.length > 0) {
        obj.variables = {};
        entries.forEach(([k, v]) => {
          obj.variables[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<LanguageBehaviorReferences>): LanguageBehaviorReferences {
    return LanguageBehaviorReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LanguageBehaviorReferences>): LanguageBehaviorReferences {
    const message = createBaseLanguageBehaviorReferences();
    message.sms = (globalThis.Object.entries(object.sms ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.handoff = (globalThis.Object.entries(object.handoff ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.attributes = (globalThis.Object.entries(object.attributes ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.globalFunctions = (globalThis.Object.entries(object.globalFunctions ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.variables = (globalThis.Object.entries(object.variables ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseLanguageBehaviorReferences_SmsEntry(): LanguageBehaviorReferences_SmsEntry {
  return { key: "", value: false };
}

export const LanguageBehaviorReferences_SmsEntry: MessageFns<LanguageBehaviorReferences_SmsEntry> = {
  encode(message: LanguageBehaviorReferences_SmsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LanguageBehaviorReferences_SmsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLanguageBehaviorReferences_SmsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LanguageBehaviorReferences_SmsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: LanguageBehaviorReferences_SmsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<LanguageBehaviorReferences_SmsEntry>): LanguageBehaviorReferences_SmsEntry {
    return LanguageBehaviorReferences_SmsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LanguageBehaviorReferences_SmsEntry>): LanguageBehaviorReferences_SmsEntry {
    const message = createBaseLanguageBehaviorReferences_SmsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseLanguageBehaviorReferences_HandoffEntry(): LanguageBehaviorReferences_HandoffEntry {
  return { key: "", value: false };
}

export const LanguageBehaviorReferences_HandoffEntry: MessageFns<LanguageBehaviorReferences_HandoffEntry> = {
  encode(message: LanguageBehaviorReferences_HandoffEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LanguageBehaviorReferences_HandoffEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLanguageBehaviorReferences_HandoffEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LanguageBehaviorReferences_HandoffEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: LanguageBehaviorReferences_HandoffEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<LanguageBehaviorReferences_HandoffEntry>): LanguageBehaviorReferences_HandoffEntry {
    return LanguageBehaviorReferences_HandoffEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LanguageBehaviorReferences_HandoffEntry>): LanguageBehaviorReferences_HandoffEntry {
    const message = createBaseLanguageBehaviorReferences_HandoffEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseLanguageBehaviorReferences_AttributesEntry(): LanguageBehaviorReferences_AttributesEntry {
  return { key: "", value: false };
}

export const LanguageBehaviorReferences_AttributesEntry: MessageFns<LanguageBehaviorReferences_AttributesEntry> = {
  encode(message: LanguageBehaviorReferences_AttributesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LanguageBehaviorReferences_AttributesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLanguageBehaviorReferences_AttributesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LanguageBehaviorReferences_AttributesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: LanguageBehaviorReferences_AttributesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<LanguageBehaviorReferences_AttributesEntry>): LanguageBehaviorReferences_AttributesEntry {
    return LanguageBehaviorReferences_AttributesEntry.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<LanguageBehaviorReferences_AttributesEntry>,
  ): LanguageBehaviorReferences_AttributesEntry {
    const message = createBaseLanguageBehaviorReferences_AttributesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseLanguageBehaviorReferences_GlobalFunctionsEntry(): LanguageBehaviorReferences_GlobalFunctionsEntry {
  return { key: "", value: false };
}

export const LanguageBehaviorReferences_GlobalFunctionsEntry: MessageFns<
  LanguageBehaviorReferences_GlobalFunctionsEntry
> = {
  encode(
    message: LanguageBehaviorReferences_GlobalFunctionsEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LanguageBehaviorReferences_GlobalFunctionsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLanguageBehaviorReferences_GlobalFunctionsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LanguageBehaviorReferences_GlobalFunctionsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: LanguageBehaviorReferences_GlobalFunctionsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(
    base?: DeepPartial<LanguageBehaviorReferences_GlobalFunctionsEntry>,
  ): LanguageBehaviorReferences_GlobalFunctionsEntry {
    return LanguageBehaviorReferences_GlobalFunctionsEntry.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<LanguageBehaviorReferences_GlobalFunctionsEntry>,
  ): LanguageBehaviorReferences_GlobalFunctionsEntry {
    const message = createBaseLanguageBehaviorReferences_GlobalFunctionsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseLanguageBehaviorReferences_VariablesEntry(): LanguageBehaviorReferences_VariablesEntry {
  return { key: "", value: false };
}

export const LanguageBehaviorReferences_VariablesEntry: MessageFns<LanguageBehaviorReferences_VariablesEntry> = {
  encode(message: LanguageBehaviorReferences_VariablesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LanguageBehaviorReferences_VariablesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLanguageBehaviorReferences_VariablesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LanguageBehaviorReferences_VariablesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: LanguageBehaviorReferences_VariablesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<LanguageBehaviorReferences_VariablesEntry>): LanguageBehaviorReferences_VariablesEntry {
    return LanguageBehaviorReferences_VariablesEntry.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<LanguageBehaviorReferences_VariablesEntry>,
  ): LanguageBehaviorReferences_VariablesEntry {
    const message = createBaseLanguageBehaviorReferences_VariablesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseLanguageBehavior(): LanguageBehavior {
  return {
    behaviorPrompt: "",
    languageCode: "",
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: undefined,
    references: undefined,
  };
}

export const LanguageBehavior: MessageFns<LanguageBehavior> = {
  encode(message: LanguageBehavior, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.behaviorPrompt !== "") {
      writer.uint32(10).string(message.behaviorPrompt);
    }
    if (message.languageCode !== "") {
      writer.uint32(18).string(message.languageCode);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(26).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(34).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(42).fork()).join();
    }
    if (message.updatedBy !== undefined) {
      writer.uint32(50).string(message.updatedBy);
    }
    if (message.references !== undefined) {
      LanguageBehaviorReferences.encode(message.references, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LanguageBehavior {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLanguageBehavior();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.behaviorPrompt = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.languageCode = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.references = LanguageBehaviorReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LanguageBehavior {
    return {
      behaviorPrompt: isSet(object.behaviorPrompt)
        ? globalThis.String(object.behaviorPrompt)
        : isSet(object.behavior_prompt)
        ? globalThis.String(object.behavior_prompt)
        : "",
      languageCode: isSet(object.languageCode)
        ? globalThis.String(object.languageCode)
        : isSet(object.language_code)
        ? globalThis.String(object.language_code)
        : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : undefined,
      references: isSet(object.references) ? LanguageBehaviorReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: LanguageBehavior): unknown {
    const obj: any = {};
    if (message.behaviorPrompt !== "") {
      obj.behaviorPrompt = message.behaviorPrompt;
    }
    if (message.languageCode !== "") {
      obj.languageCode = message.languageCode;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== undefined) {
      obj.updatedBy = message.updatedBy;
    }
    if (message.references !== undefined) {
      obj.references = LanguageBehaviorReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<LanguageBehavior>): LanguageBehavior {
    return LanguageBehavior.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LanguageBehavior>): LanguageBehavior {
    const message = createBaseLanguageBehavior();
    message.behaviorPrompt = object.behaviorPrompt ?? "";
    message.languageCode = object.languageCode ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? LanguageBehaviorReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseLanguageBehaviorUpdateLanguageBehavior(): LanguageBehaviorUpdateLanguageBehavior {
  return { languageCode: "", behaviorPrompt: undefined, references: undefined };
}

export const LanguageBehaviorUpdateLanguageBehavior: MessageFns<LanguageBehaviorUpdateLanguageBehavior> = {
  encode(message: LanguageBehaviorUpdateLanguageBehavior, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.languageCode !== "") {
      writer.uint32(10).string(message.languageCode);
    }
    if (message.behaviorPrompt !== undefined) {
      writer.uint32(18).string(message.behaviorPrompt);
    }
    if (message.references !== undefined) {
      LanguageBehaviorReferences.encode(message.references, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LanguageBehaviorUpdateLanguageBehavior {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLanguageBehaviorUpdateLanguageBehavior();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.languageCode = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.behaviorPrompt = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.references = LanguageBehaviorReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LanguageBehaviorUpdateLanguageBehavior {
    return {
      languageCode: isSet(object.languageCode)
        ? globalThis.String(object.languageCode)
        : isSet(object.language_code)
        ? globalThis.String(object.language_code)
        : "",
      behaviorPrompt: isSet(object.behaviorPrompt)
        ? globalThis.String(object.behaviorPrompt)
        : isSet(object.behavior_prompt)
        ? globalThis.String(object.behavior_prompt)
        : undefined,
      references: isSet(object.references) ? LanguageBehaviorReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: LanguageBehaviorUpdateLanguageBehavior): unknown {
    const obj: any = {};
    if (message.languageCode !== "") {
      obj.languageCode = message.languageCode;
    }
    if (message.behaviorPrompt !== undefined) {
      obj.behaviorPrompt = message.behaviorPrompt;
    }
    if (message.references !== undefined) {
      obj.references = LanguageBehaviorReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<LanguageBehaviorUpdateLanguageBehavior>): LanguageBehaviorUpdateLanguageBehavior {
    return LanguageBehaviorUpdateLanguageBehavior.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LanguageBehaviorUpdateLanguageBehavior>): LanguageBehaviorUpdateLanguageBehavior {
    const message = createBaseLanguageBehaviorUpdateLanguageBehavior();
    message.languageCode = object.languageCode ?? "";
    message.behaviorPrompt = object.behaviorPrompt ?? undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? LanguageBehaviorReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
